export enum ApiRoutesAuth {
  Login = "admin/auth/sign-in",
  Logout = "admin/auth/logout"
}
